import React, { useEffect, useState } from 'react';
import { fetchReliabilityScores } from '../../../Service/APIService';
import TableHeader from '../../Custom/TableHeader';

const ReliabilityScores = ({ type, id, yyyymm }) => {
  const [scoreValues, setScoreValues] = useState({});

  useEffect(() => {
    fetchReliabilityScores(type, id, yyyymm).then((res) =>
      setScoreValues(res.data.statusCode === 200 ? res.data.result : {})
    );
  }, [type, id, yyyymm]);

  return (
    <TableHeader title={'Reliability Indices'}>
      <table className="tbl">
        <thead>
          <tr>
            <th>Reliability Metric</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td width="60%">SAIDI</td>
            <td width="40%">
              <span className="pull-left">
                {scoreValues?.saidi?.toFixed(2)} Minutes
              </span>
            </td>
          </tr>
          <tr>
            <td width="60%">SAIFI</td>
            <td width="40%">
              <span className="pull-right">
                {scoreValues?.saifi?.toFixed(2)} Interruptions Count
              </span>
            </td>
          </tr>
          <tr>
            <td width="60%">CAIDI</td>
            <td width="40%">
              <span className="pull-left">
                {scoreValues?.caidi?.toFixed(2)} Minutes
              </span>
            </td>
          </tr>
          <tr>
            <td width="60%">CAIFI</td>
            <td width="40%">
              <span className="pull-right">
                {scoreValues?.caifi?.toFixed(2)} Interruptions Count
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </TableHeader>
  );
};

export default ReliabilityScores;
